import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import ActiveTable from "./Tables/ActiveTable";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component="span">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`
  };
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper
  }
}));

const TabEndowments = props => {
  const classes = useStyles();
  const { activas, inactivas, setTabValue } = props;
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setTabValue(newValue);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="simple tabs example"
          centered
        >
          <Tab
            style={{ textTransform: "none" }}
            label="Activas"
            {...a11yProps(0)}
          />
          <Tab
            style={{ textTransform: "none" }}
            label="Inactivas"
            {...a11yProps(1)}
          />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        <ActiveTable
          data={activas}
          isTENS={props.isTENS}
          attendanceStatusByFicha={props.attendanceStatusByFicha}
          attendanceDetailByFicha={props.attendanceDetailByFicha}
          attendanceDate={props.attendanceDate}
        />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <ActiveTable data={inactivas} isTENS={props.isTENS} />
      </TabPanel>
    </div>
  );
};

export default TabEndowments;

TabEndowments.propTypes = {
  activas: PropTypes.array,
  inactivas: PropTypes.array,
  setTabValue: PropTypes.func,
  attendanceStatusByFicha: PropTypes.object,
  attendanceDetailByFicha: PropTypes.object,
  attendanceDate: PropTypes.object
};
